import { ErrorMessage, Field, Form, Formik } from "formik";
import React from "react";
import { Button, Col, Label, Row } from "reactstrap";
import {
  ConfirmPassword,
  Email,
  EmailPlaceHolder,
  EnterConfirmPassword,
  EnterPassword,
  Password,
} from "../../utils/Constant";
import { StaticModalToggleProp } from "../../types/modal/ModalTypes";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";

const ResetForm: React.FC<StaticModalToggleProp> = ({
  staticModalToggle,
  data,
}) => {
  const { t } = useTranslation();

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
        "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
      )
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Passwords must match")
      .required("Confirm Password is required"),
  });

  return (
    <Formik
      initialValues={{
        email: data?.email || "",
        password: "",
        confirmPassword: "",
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        // Handle form submission here
        console.log("Form values:", values);
        staticModalToggle(); // Close modal after submission
      }}
    >
      {({ errors, touched }) => (
        <Form>
          <Row className="g-3">
            <Col md="12">
              <Label>{Email}</Label>
              <Field
                className="form-control"
                name="email"
                type="email"
                placeholder={EmailPlaceHolder}
                readOnly
              />
              <ErrorMessage
                name="email"
                component="span"
                className="text-danger"
              />
            </Col>
            <Col xs="12">
              <Label check>
                {Password} <span className="txt-danger">*</span>
              </Label>
              <Field
                className="form-control"
                name="password"
                type="password"
                placeholder={EnterPassword}
                autoComplete="new-password"
              />
              <ErrorMessage
                name="password"
                component="span"
                className="text-danger"
              />
            </Col>
            <Col xs="12">
              <Label check>
                {ConfirmPassword} <span className="txt-danger">*</span>
              </Label>
              <Field
                className="form-control"
                name="confirmPassword"
                type="password"
                placeholder={EnterConfirmPassword}
                autoComplete="new-password"
              />
              <ErrorMessage
                name="confirmPassword"
                component="span"
                className="text-danger"
              />
            </Col>
            <div className="text-end mt-3">
              <Button
                color="secondary"
                className="me-2"
                type="button"
                onClick={staticModalToggle}
              >
                {t("Cancel")}
              </Button>
              <Button color="primary" type="submit">
                {t("Save")}
              </Button>
            </div>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default ResetForm;